import './style.scss';
import Rating from './rating.js';

export default Rating;